export const PhotovoltaicRoute = "/dlp/solaranlage-mieten-oder-kaufen?nav=1";
export const PhotovoltaicRouteB2B = "/dlp/solaranlage-mieten-oder-kaufen-b2b?nav=1";
